import { render, staticRenderFns } from "./ProceedButton.vue?vue&type=template&id=5043e85d&scoped=true"
import script from "./ProceedButton.vue?vue&type=script&lang=js"
export * from "./ProceedButton.vue?vue&type=script&lang=js"
import style0 from "./ProceedButton.vue?vue&type=style&index=0&id=5043e85d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5043e85d",
  null
  
)

export default component.exports